import { CreateDealDto } from "../../shared/swagger/client/api-client";

export const newDealsData: CreateDealDto[] = [
    {
           vin: "3B7HF16Z8XM506485",
           price: 42500,
           title: "BMW i3",
           mileage: 12000,
           stockNumber: "DE2255",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "BMW",
           model: "i3",
           status: "active"
    },
    {
           vin: "1HGCR2F5XFA027534",
           price: 48900,
           title: "Tesla Model 3",
           mileage: 8500,
           stockNumber: "TS1045",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2020,
           make: "Tesla",
           model: "Model 3",
           status: "active"
    },
    {
           vin: "WAUAFAFL1GN014921",
           price: 37800,
           title: "Audi A4",
           mileage: 25300,
           stockNumber: "AU3892",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2018,
           make: "Audi",
           model: "A4",
           status: "active"
    },
    {
           vin: "WDDWJ8KB2KF684356",
           price: 43200,
           title: "Mercedes-Benz C-Class",
           mileage: 18700,
           stockNumber: "MB4567",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Mercedes-Benz",
           model: "C-Class",
           status: "active"
    },
    {
           vin: "4T1BF1FK3GU589142",
           price: 26500,
           title: "Toyota Camry",
           mileage: 32000,
           stockNumber: "TC7832",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2017,
           make: "Toyota",
           model: "Camry",
           status: "active"
    },
    {
           vin: "2HGFC2F55MH567890",
           price: 22900,
           title: "Honda Civic",
           mileage: 28400,
           stockNumber: "HC1234",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2021,
           make: "Honda",
           model: "Civic",
           status: "active"
    },
    {
           vin: "1FA6P8TH4K5123456",
           price: 39500,
           title: "Ford Mustang",
           mileage: 15200,
           stockNumber: "FM4587",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Ford",
           model: "Mustang",
           status: "active"
    },
    {
           vin: "1G1YF3D44L5800123",
           price: 72000,
           title: "Chevrolet Corvette",
           mileage: 5200,
           stockNumber: "CC8901",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2020,
           make: "Chevrolet",
           model: "Corvette",
           status: "active"
    },
    {
           vin: "WVWAA7AJ9JW283456",
           price: 28700,
           title: "Volkswagen Golf",
           mileage: 22100,
           stockNumber: "VG4329",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2018,
           make: "Volkswagen",
           model: "Golf",
           status: "active"
    },
    {
           vin: "WP0AB2A9XKS223344",
           price: 112500,
           title: "Porsche 911",
           mileage: 9800,
           stockNumber: "PS9110",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Porsche",
           model: "911",
           status: "active"
    },
    {
           vin: "5NPE34AF1KH745678",
           price: 24800,
           title: "Hyundai Sonata",
           mileage: 31500,
           stockNumber: "HS6721",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Hyundai",
           model: "Sonata",
           status: "active"
    },
    {
           vin: "KNAGT4L30K5123789",
           price: 22500,
           title: "Kia Optima",
           mileage: 29700,
           stockNumber: "KO5432",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Kia",
           model: "Optima",
           status: "active"
    },
    {
           vin: "JF1ZNAE17G8700234",
           price: 25900,
           title: "Subaru Impreza",
           mileage: 27800,
           stockNumber: "SI4398",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2016,
           make: "Subaru",
           model: "Impreza",
           status: "active"
    },
    {
           vin: "1N4BL4BV2KC205678",
           price: 23400,
           title: "Nissan Altima",
           mileage: 35200,
           stockNumber: "NA8742",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Nissan",
           model: "Altima",
           status: "active"
    },
    {
           vin: "JTHBK1GG7F2134567",
           price: 42900,
           title: "Lexus ES",
           mileage: 19800,
           stockNumber: "LE5431",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2015,
           make: "Lexus",
           model: "ES",
           status: "active"
    },
    {
           vin: "YV4A22PL8K1156789",
           price: 54200,
           title: "Volvo XC90",
           mileage: 16700,
           stockNumber: "VX9087",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Volvo",
           model: "XC90",
           status: "active"
    },
    {
           vin: "SALWR2RK8KA878901",
           price: 68500,
           title: "Range Rover Sport",
           mileage: 12500,
           stockNumber: "RR3456",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Land Rover",
           model: "Range Rover Sport",
           status: "active"
    },
    {
           vin: "SAJDD5EV8JCK23456",
           price: 75800,
           title: "Jaguar F-Type",
           mileage: 8900,
           stockNumber: "JF7654",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2018,
           make: "Jaguar",
           model: "F-Type",
           status: "active"
    },
    {
           vin: "ZFF79ALA7K0245678",
           price: 289000,
           title: "Ferrari 488 GTB",
           mileage: 3500,
           stockNumber: "FR4882",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Ferrari",
           model: "488 GTB",
           status: "active"
    },
    {
           vin: "ZHWUR2ZF9KLA09876",
           price: 325000,
           title: "Lamborghini Huracan",
           mileage: 2800,
           stockNumber: "LH5678",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Lamborghini",
           model: "Huracan",
           status: "active"
    },
    {
           vin: "ZAM57XSA9J1312345",
           price: 78900,
           title: "Maserati Ghibli",
           mileage: 11300,
           stockNumber: "MG6754",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2018,
           make: "Maserati",
           model: "Ghibli",
           status: "active"
    },
    {
           vin: "SCBCR63W86C045678",
           price: 198500,
           title: "Bentley Continental GT",
           mileage: 7800,
           stockNumber: "BC9087",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2006,
           make: "Bentley",
           model: "Continental GT",
           status: "active"
    },
    {
           vin: "SCA1S68085UX56789",
           price: 455000,
           title: "Rolls-Royce Phantom",
           mileage: 4200,
           stockNumber: "RR1234",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2005,
           make: "Rolls-Royce",
           model: "Phantom",
           status: "active"
    },
    {
           vin: "VF9SP3V3XJSM78901",
           price: 3200000,
           title: "Bugatti Chiron",
           mileage: 1200,
           stockNumber: "BC5678",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Bugatti",
           model: "Chiron",
           status: "active"
    },
    {
           vin: "SBM14DCA0KW000123",
           price: 289000,
           title: "McLaren 720S",
           mileage: 2500,
           stockNumber: "MC7201",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "McLaren",
           model: "720S",
           status: "active"
    },
    {
           vin: "SCFFDECN7JGJ34567",
           price: 225000,
           title: "Aston Martin DB11",
           mileage: 6300,
           stockNumber: "AM1100",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2018,
           make: "Aston Martin",
           model: "DB11",
           status: "active"
    },
    {
           vin: "ZARFAEBN7K7678901",
           price: 45800,
           title: "Alfa Romeo Giulia",
           mileage: 14700,
           stockNumber: "AR4321",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2019,
           make: "Alfa Romeo",
           model: "Giulia",
           status: "active"
    },
    {
           vin: "3C3CFFFH9FT512345",
           price: 18900,
           title: "Fiat 500",
           mileage: 26500,
           stockNumber: "FT5000",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2015,
           make: "Fiat",
           model: "500",
           status: "active"
    },
    {
           vin: "WMWXU3C56F3B56789",
           price: 24500,
           title: "Mini Cooper",
           mileage: 19800,
           stockNumber: "MC4356",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2015,
           make: "Mini",
           model: "Cooper",
           status: "active"
    },
    {
           vin: "JM1NDAD76K0123456",
           price: 32800,
           title: "Mazda MX-5 Miata",
           mileage: 8700,
           stockNumber: "MM5432",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2021,
           make: "Mazda",
           model: "MX-5 Miata",
           status: "active"
    },
    {
           vin: "1HGCM82633A004567",
           price: 45800,
           title: "BMW i3 - new",
           mileage: 5000,
           stockNumber: "BM1001",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "BMW",
           model: "i3",
           status: "active"
    },
    {
           vin: "2T3RFREV8FW312345",
           price: 52300,
           title: "Tesla Model S - new",
           mileage: 2000,
           stockNumber: "TS2001",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Tesla",
           model: "Model S",
           status: "active"
    },
    {
           vin: "5YJSA1E40HF176543",
           price: 58900,
           title: "Mercedes-Benz EQS - new",
           mileage: 1500,
           stockNumber: "MB2002",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Mercedes-Benz",
           model: "EQS",
           status: "active"
    },
    {
           vin: "JN1CV6AP3CM456789",
           price: 41200,
           title: "Audi e-tron - new",
           mileage: 3500,
           stockNumber: "AU2003",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Audi",
           model: "e-tron",
           status: "active"
    },
    {
           vin: "1G1FZ6S01J4123456",
           price: 34500,
           title: "Chevrolet Bolt - new",
           mileage: 2800,
           stockNumber: "CB2004",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Chevrolet",
           model: "Bolt",
           status: "active"
    },
    {
           vin: "KNDPM3AC1L7778899",
           price: 36900,
           title: "Hyundai Ioniq 5 - new",
           mileage: 1200,
           stockNumber: "HI2005",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Hyundai",
           model: "Ioniq 5",
           status: "active"
    },
    {
           vin: "SALVA2AE8LH334455",
           price: 69800,
           title: "Range Rover Evoque - new",
           mileage: 4500,
           stockNumber: "RR2006",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Land Rover",
           model: "Range Rover Evoque",
           status: "active"
    },
    {
           vin: "5XXGT4L37JG223344",
           price: 39500,
           title: "Kia EV6 - new",
           mileage: 1800,
           stockNumber: "KE2007",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Kia",
           model: "EV6",
           status: "active"
    },
    {
           vin: "7FARW2H56NE667788",
           price: 42300,
           title: "Honda Clarity - new",
           mileage: 2900,
           stockNumber: "HC2008",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Honda",
           model: "Clarity",
           status: "active"
    },
    {
           vin: "1FTEW1EP7MFA11223",
           price: 56700,
           title: "Ford Mustang Mach-E - new",
           mileage: 1700,
           stockNumber: "FM2009",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Ford",
           model: "Mustang Mach-E",
           status: "active"
    },
    {
           vin: "WAULFAFR1LA556677",
           price: 61200,
           title: "Porsche Taycan - new",
           mileage: 1500,
           stockNumber: "PT2010",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Porsche",
           model: "Taycan",
           status: "active"
    },
    {
           vin: "SJKCH5CR6HA334455",
           price: 47800,
           title: "Nissan Ariya - new",
           mileage: 2200,
           stockNumber: "NA2011",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Nissan",
           model: "Ariya",
           status: "active"
    },
    {
           vin: "SJAEE74C97S112233",
           price: 44900,
           title: "Jaguar I-PACE - new",
           mileage: 3600,
           stockNumber: "JI2012",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Jaguar",
           model: "I-PACE",
           status: "active"
    },
    {
           vin: "YV1LW76A6X2445566",
           price: 57300,
           title: "Volvo C40 Recharge - new",
           mileage: 1900,
           stockNumber: "VC2013",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Volvo",
           model: "C40 Recharge",
           status: "active"
    },
    {
           vin: "WA1LHAF79LD998877",
           price: 51900,
           title: "Audi Q4 e-tron - new",
           mileage: 2000,
           stockNumber: "AQ2014",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Audi",
           model: "Q4 e-tron",
           status: "active"
    },
    {
           vin: "JF2SKADC7LH112233",
           price: 39200,
           title: "Subaru Solterra - new",
           mileage: 1400,
           stockNumber: "SS2015",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Subaru",
           model: "Solterra",
           status: "active"
    },
    {
           vin: "JTMDJREV0LD334455",
           price: 45600,
           title: "Toyota bZ4X - new",
           mileage: 1600,
           stockNumber: "TB2016",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Toyota",
           model: "bZ4X",
           status: "active"
    },
    {
           vin: "KNAGD128795667788",
           price: 37800,
           title: "Genesis GV60 - new",
           mileage: 1700,
           stockNumber: "GG2017",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Genesis",
           model: "GV60",
           status: "active"
    },
    {
           vin: "1ZVHT82H485112233",
           price: 67500,
           title: "Lexus RZ - new",
           mileage: 800,
           stockNumber: "LR2018",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Lexus",
           model: "RZ",
           status: "active"
    },
    {
           vin: "3FAHP0CG9AR778899",
           price: 49200,
           title: "Polestar 2 - new",
           mileage: 2100,
           stockNumber: "PS2019",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Polestar",
           model: "2",
           status: "active"
    },
    {
           vin: "WDDNG7DB8DA223344",
           price: 72900,
           title: "Mercedes-Benz EQE - new",
           mileage: 1200,
           stockNumber: "ME2020",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Mercedes-Benz",
           model: "EQE",
           status: "active"
    },
    {
           vin: "WMWXM5C56F3B56789",
           price: 33500,
           title: "Mini Cooper Electric - new",
           mileage: 1500,
           stockNumber: "MC2021",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Mini",
           model: "Cooper Electric",
           status: "active"
    },
    {
           vin: "ZFFAA123456789012",
           price: 375000,
           title: "Ferrari SF90 Stradale - new",
           mileage: 500,
           stockNumber: "FS2022",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Ferrari",
           model: "SF90 Stradale",
           status: "active"
    },
    {
           vin: "LLKVS5DAXN8123456",
           price: 82500,
           title: "Lucid Air - new",
           mileage: 900,
           stockNumber: "LA2023",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Lucid",
           model: "Air",
           status: "active"
    },
    {
           vin: "RVYFDM442NT987654",
           price: 69800,
           title: "Rivian R1T - new",
           mileage: 1100,
           stockNumber: "RT2024",
           primaryImage: "https://w7.pngwing.com/pngs/135/245/png-transparent-2012-kia-optima-2013-kia-optima-car-2011-kia-optima-kia-compact-car-sedan-driving.png",
           year: 2022,
           make: "Rivian",
           model: "R1T",
           status: "active"
    }
];
